import { render, staticRenderFns } from "./TrustpilotTable.vue?vue&type=template&id=beb60d10&scoped=true&"
import script from "./TrustpilotTable.vue?vue&type=script&lang=js&"
export * from "./TrustpilotTable.vue?vue&type=script&lang=js&"
import style0 from "./TrustpilotTable.vue?vue&type=style&index=0&id=beb60d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb60d10",
  null
  
)

export default component.exports